import classnames from 'classnames/bind'
import { TPreference } from '@/types/preference-tag'
// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type BarItemProps = {
  handleItemClick: (data: TPreference) => void
  isEditMode: boolean
  icon?: React.ReactNode
} & TPreference

const PreferenceTagItem = ({ tagName, preferenceTag, handleItemClick = () => {}, isEditMode = false, icon = <></>, isDefault }: BarItemProps) => {
  const dataIsEdit = !!isEditMode && !isDefault
  return (
    <div className={cx('tag-item', { isDefault })} onClick={() => handleItemClick({ tagName, preferenceTag, isDefault })}>
      <div className={cx('tag-item-edit')} data-is-edit={dataIsEdit}>
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g clipPath='url(#clip0_539_3553)'>
            <circle cx='7' cy='7' r='6' fill='white' />
            <path
              d='M8.74999 5.25002L6.99999 7.00002M6.99999 7.00002L5.24999 8.75002M6.99999 7.00002L8.74999 8.75002M6.99999 7.00002L5.24999 5.25002M12.8333 7.00002C12.8333 10.2217 10.2217 12.8334 6.99999 12.8334C3.77833 12.8334 1.16666 10.2217 1.16666 7.00002C1.16666 3.77836 3.77833 1.16669 6.99999 1.16669C10.2217 1.16669 12.8333 3.77836 12.8333 7.00002Z'
              stroke='#7F848E'
              strokeWidth='1.2'
              strokeLinecap='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_539_3553'>
              <rect width='14' height='14' fill='white' />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className={cx('tag-item-text')}>
        <div className={cx('tag-item-icon')}>{icon}</div>
        <div className={cx('tag-item-name')}>{tagName}</div>
      </div>
    </div>
  )
}
export default PreferenceTagItem
